/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentRazorpayType = "RAZORPAY" | "X_RAZORPAY" | "%future added value";
export type AddMoneyToWalletMutationVariables = {|
  amount: number
|};
export type AddMoneyToWalletMutationResponse = {|
  +updateWallet: ?{|
    +payment: ?{|
      +id: string,
      +user: {|
        +username: string,
        +firstName: string,
        +mobileNumber: string,
        +email: ?string,
      |},
      +razorpayOrderId: string,
      +paymentStatus: ?string,
      +capturedAmount: number,
      +razorpayPaymentId: ?string,
      +paymentMethod: ?string,
      +razorpayType: PaymentRazorpayType,
      +xRazorpayResponse: ?any,
    |}
  |}
|};
export type AddMoneyToWalletMutation = {|
  variables: AddMoneyToWalletMutationVariables,
  response: AddMoneyToWalletMutationResponse,
|};
*/


/*
mutation AddMoneyToWalletMutation(
  $amount: Int!
) {
  updateWallet(amount: $amount) {
    payment {
      id
      user {
        username
        firstName
        mobileNumber
        email
      }
      razorpayOrderId
      paymentStatus
      capturedAmount
      razorpayPaymentId
      paymentMethod
      razorpayType
      xRazorpayResponse
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "amount"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "amount",
        "variableName": "amount"
      }
    ],
    "concreteType": "WalletUpdate",
    "kind": "LinkedField",
    "name": "updateWallet",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PaymentNode",
        "kind": "LinkedField",
        "name": "payment",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "username",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mobileNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "razorpayOrderId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "capturedAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "razorpayPaymentId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentMethod",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "razorpayType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xRazorpayResponse",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddMoneyToWalletMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddMoneyToWalletMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "515fa7e3863beca779a37936236370a7",
    "id": null,
    "metadata": {},
    "name": "AddMoneyToWalletMutation",
    "operationKind": "mutation",
    "text": "mutation AddMoneyToWalletMutation(\n  $amount: Int!\n) {\n  updateWallet(amount: $amount) {\n    payment {\n      id\n      user {\n        username\n        firstName\n        mobileNumber\n        email\n      }\n      razorpayOrderId\n      paymentStatus\n      capturedAmount\n      razorpayPaymentId\n      paymentMethod\n      razorpayType\n      xRazorpayResponse\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '3efd723f8d9328d52e41561cca4908ec';

module.exports = node;
